import { render, staticRenderFns } from "./StandardHome.vue?vue&type=template&id=3958de23&scoped=true&"
import script from "./StandardHome.vue?vue&type=script&lang=js&"
export * from "./StandardHome.vue?vue&type=script&lang=js&"
import style0 from "./StandardHome.vue?vue&type=style&index=0&id=3958de23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3958de23",
  null
  
)

export default component.exports